import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { History } from 'history';

const createTelemetryService = () => {
    let reactPlugin: ReactPlugin | null = null;
    let appInsights: ApplicationInsights | null = null;

    const initialize = (instrumentationKey: string, browserHistory: History<any>) => {
        if (!instrumentationKey || !browserHistory)
            throw new Error('Could not initialize Telemetry Service');

        reactPlugin = new ReactPlugin();

        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: {
                        history: browserHistory
                    }
                }
            }
        });

        appInsights.loadAppInsights();
        (appInsights as ApplicationInsights).appInsights.addTelemetryInitializer((telemetryItem: ITelemetryItem) => {
            if (!telemetryItem.tags)
                telemetryItem.tags = [];

            telemetryItem.tags['ai.cloud.role'] = "WebSPA";
        });
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();